import { render } from "./Carriers.vue?vue&type=template&id=59a7e5bb&scoped=true&ts=true"
import script from "./Carriers.vue?vue&type=script&lang=ts"
export * from "./Carriers.vue?vue&type=script&lang=ts"

import "./Carriers.vue?vue&type=style&index=0&id=59a7e5bb&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a7e5bb"]])

export default __exports__